import {
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  calendarOutline,
  calendar,
  logOutOutline,
  logOut,
  gridOutline,
  grid,
  logoWhatsapp,
  peopleCircleOutline,
  peopleCircle,
  readerOutline,
  reader,
  createOutline,
} from "ionicons/icons";
import "./Menu.css";
import { useEffect, useState } from "react";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const appPages = [
    {
      title: "Inicio",
      url: "/portal/Inicio",
      iosIcon: gridOutline,
      mdIcon: grid,
    },
    {
      title: "Reservar Turno",
      url: "/portal/Reservar turno",
      iosIcon: peopleCircleOutline,
      mdIcon: peopleCircle,
    },
    // {
    //   title: "Horarios Equipos",
    //   url: "/portal/Horarios",
    //   iosIcon: peopleOutline,
    //   mdIcon: people,
    // },
    {
      title: "Mis Turnos",
      url: "/portal/Turnos",
      iosIcon: calendarOutline,
      mdIcon: calendar,
    },
    // {
    //   title: "Mis Estudios",
    //   url: "/portal/Estudios",
    //   iosIcon: fileTrayFullOutline,
    //   mdIcon: fileTrayFull,
    // },
    {
      title: "Mis Imagenes",
      url: "/portal/Imagenes",
      iosIcon: readerOutline,
      mdIcon: reader,
    },
  ];

  const history = useHistory();
  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, []);
  useEffect(() => {}, [openModalPaciente]);

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent fullscreen>
        <div className="menu-layout">
          <div className="menu-scroll-container">
            <IonImg src="assets/logo.png" />
            <IonList id="inbox-list">
              <div onClick={() => setOpenModalPaciente(true)}>
                <IonListHeader className="encabezado">
                  {usuario.apellido}, {usuario.nombre}
                  <IonIcon
                    icon={createOutline}
                    style={{
                      marginLeft: "10px",
                      fontSize: "25px",
                      cursor: "pointer",
                      color: "#80c423",
                    }}
                    title="Ver datos de usuario"
                  />
                </IonListHeader>
                <IonNote>{usuario.email}</IonNote>
              </div>

              {appPages.map((appPage, index) => {
                return (
                  <IonMenuToggle key={index} autoHide={false}>
                    <IonItem
                      className={
                        location.pathname === appPage.url ? "selected" : ""
                      }
                      routerLink={appPage.url}
                      routerDirection="none"
                      lines="none"
                      detail={false}
                    >
                      <IonIcon
                        aria-hidden="true"
                        slot="start"
                        ios={appPage.iosIcon}
                        md={appPage.mdIcon}
                      />
                      <IonLabel>{appPage.title}</IonLabel>
                    </IonItem>
                  </IonMenuToggle>
                );
              })}
              <IonItem lines="none" className="amarillo-sol">
                <IonIcon slot="start" icon={logoWhatsapp} />
                <IonLabel>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://api.whatsapp.com/send?phone=5493513455853&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20realizar%20una%20consulta."
                  >
                    Nuestro Whatsapp
                  </a>
                </IonLabel>
              </IonItem>
            </IonList>
            <IonItem button fill="clear" lines="none" routerLink={"/"}>
              <IonIcon
                aria-hidden="true"
                color="solid"
                slot="start"
                ios={logOutOutline}
                md={logOut}
              />
              <IonLabel color="danger">Cerrar Sesion</IonLabel>
            </IonItem>
          </div>

          <div className="menu-footer">
            <a
              className="menu-footer-link"
              href="https://www.gacitua.com.ar/"
              rel="noreferrer"
              target="_blank"
            >
              <span>Powered by</span>
              <img
                src="assets/logoGacitua.png"
                alt="logo gacitua y asociados"
                width={17}
                height={17}
              />
              <span>Gacitua & Asociados</span>
            </a>
          </div>
        </div>
      </IonContent>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
      />
    </IonMenu>
  );
};

export default Menu;
